import { render } from "./CopyAppointment.vue?vue&type=template&id=e4cf7fae&scoped=true&ts=true"
import script from "./CopyAppointment.vue?vue&type=script&lang=ts"
export * from "./CopyAppointment.vue?vue&type=script&lang=ts"

import "./CopyAppointment.vue?vue&type=style&index=0&id=e4cf7fae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4cf7fae"]])

export default __exports__